import { camelize } from 'casing'
import {
  ReferralsContent,
  ReferralsResponse,
} from '../../../oppsync/modules/CoSell/actions'
import {
  ReferralAPI,
  ReferralObject,
  Referral,
  ReferralReferredBy,
  ReferralSyncStatus,
} from '../../../oppsync/modules/CoSell/reducer'

import { errorLogger } from '../ErrorHandler'
import { AppAlertState } from '../../modules/appAlert/reducer'
import {
  ReferralOppSections,
  SaaSDocumentation,
} from '../../../oppsync/modules/CoSell/ReferralForm/reducer'
import {
  contractEffectiveDateRequiredMessage,
  contractExpirationDateRequiredMessage,
  customerSoftwareValueRequiredMessage,
  procurementTypeRequiredMessage,
  saasDocumentationCurrencyRequiredMessage,
} from '../messagesContants'
import {
  ReferralLead,
  ReferralLeadAPI,
  mapKeysLeadApiToLead,
} from '../../../oppsync/modules/CoSell/LeadsReferralForm/types'
import {
  LeadStage,
  ReferralStage,
  ReferralStatus,
  SyncDirection,
} from '../../../oppsync/components/CoSell/types'
import {
  CloudAccountType,
  StagesChipsState,
  StatusChipsState,
  SyncStatusState,
  SyncStatusV3Type,
} from '@labrav/react-components'
import { CloudType } from '../../modules/types'

export const getReferredBy = (val: string): ReferralReferredBy => {
  if (val?.includes('AWS')) {
    return 'AWS Referral'
  }
  return 'Partner Referral'
}

const mapKeysReferralApiToReferral: Record<keyof ReferralAPI, keyof Referral> =
  {
    Labra__Company_Name__c: 'companyName',
    Id: 'id',
    Labra__Primary_Sales_Rep_First_Name__c: 'partnerContactFirstName',
    Labra__Primary_Sales_Rep_Last_Name__c: 'partnerContactLastName',
    Labra__Referral_Stage__c: 'stage',
    Labra__Target_Close_Date__c: 'targetCloseDate',
    Labra__Last_Updated__c: 'lastUpdated',
    Labra__Cloud_Provider_Approval_Status__c: 'cloudProviderApprovalStatus',
    Labra__Referral_Owner__c: 'referralOwner',
    Labra__Created_Date__c: 'createdDate',
    Labra__Last_Sync_Status__c: 'lastSyncStatus',
    Labra__acceptBy__c: 'acceptByDate',
    Labra__AWS_Acceptance_Status__c: 'cloudProviderAcceptanceStatus',
    Labra__Customer_First_Name__c: 'customerFirstName',
    Labra__Customer_Last_Name__c: 'customerLastName',
    Labra__Acceptance_Status__c: 'acceptanceStatus',
    Labra__Use_Case__c: 'useCase',
    Labra__Country__c: 'country',
    Labra__Delivery_Model__c: 'deliveryModel',
    Labra__Expected_Monthly_AWS_Revenue__c: 'expectedMonthlyAwsRevenue',
    Labra__Industry__c: 'industry',
    Labra__IsOppFromMarketingActivity__c: 'isThisFromMarketing',
    Labra__Postal_Code__c: 'postalCode',
    Labra__Primary_Need_From_AWS_MultiSelect__c: 'partnerPrimaryNeedFromAws',
    Labra__Website__c: 'website',
    Name: 'partnerProjectTitle',
    Labra__City__c: 'city',
    Labra__State__c: 'state',
    Labra__Description__c: 'customerBusinessProblem',
    Labra__Offer_ID__c: 'labraOffer',
    Labra__Customer_Title__c: 'customerTitle',
    Labra__Customer_Phone__c: 'phone',
    Labra__Customer_Email__c: 'customerEmail',
    Labra__Solution_offered__c: 'solutionOffered',
    Labra__Opportunity_Type__c: 'opportunityType',
    Labra__Sales_Activities__c: 'salesActivities',
    Labra__AWS_Partner_Central_User_Email__c: 'opportunityOwnerEmail',
    Labra__AWS_Partner_Central_User_Name__c: 'opportunityOwnerName',
    Labra__APN_CRM_Unique_Identifier__c: 'crmUniqueIdentifier',
    Labra__AWS_Lead_Status__c: 'leadStatus',
    Labra__Referred_By__c: 'referredBy',
    Labra__Next_Step_History__c: 'nextStepHistory',
    Labra__Next_step__c: 'nextStep',
    Labra__AWS_Internal_Stage__c: 'internalStage',
    Labra__AWS_Account_Id__c: 'awsAccountId',
    Labra__AWS_Account_Owner_Email__c: 'awsAccountOwnerEmail',
    Labra__AWS_Account_Owner_Name__c: 'awsAccountOwnerName',
    Labra__AWS_Sales_Rep_Email__c: 'awsSalesRepEmail',
    Labra__AWS_Sales_Rep_Name__c: 'awsSalesRepName',
    Labra__Primary_Sales_Rep_Email__c: 'partnerSalesContactEmail',
    Labra__Primary_Sales_Rep_Phone__c: 'partnerSalesContactPhone',
    Labra__ISV_Manager_Email__c: 'awsIsvSuccessManagerEmail',
    Labra__ISV_Manager_Name__c: 'awsIsvSuccessManagerName',
    Labra__Competitive_Tracking__c: 'competitiveTracking',
    Labra__Sender_Company_Name__c: 'senderCompanyName',
    Labra__Sender_Company_Domain__c: 'senderCompanyDomain',
    Labra__Sender_Contact_Email__c: 'senderContactEmail',
    Labra__Sender_Contact_First_Name__c: 'senderContactFirstName',
    Labra__Sender_Contact_Last_Name__c: 'senderContactLastName',
    Labra__Street_Address__c: 'streetAddress',
    Labra__Success_Manager_Email__c: 'psmEmail',
    Labra__Success_Manager_Name__c: 'psmName',
    Labra__Customer_DUNS__c: 'duns',
    Labra__AWS_products__c: 'awsProducts',
    Labra__Rejection_reason__c: 'rejectionReason',
    Labra__AWS_Closed_Lost_Reason__c: 'closedReason',
    Labra__Has_classified_NatSec_Information__c:
      'hasClassifiedNationalSecurityInformation',
    Labra__AWS_Closed_Lost_Reason_Code__c: 'awsClosedReason',
    Labra__Additional_Comments__c: 'additionalComments',
    Labra__AWS_Close_Date__c: 'awsCloseDate',
    Labra__contractStartDate__c: 'contractEffectiveDate',
    Labra__contractEndDate__c: 'contractExpirationDate',
    Labra__customerSoftwareValueCurrency__c: 'currency',
    Labra__customerSoftwareValue__c: 'customerSoftwareValue',
    Labra__procurementType__c: 'procurementType',
    Labra__marketingActivityChannel__c: 'marketingActivityChannel',
    Labra__marketingActivityUsecase__c: 'marketingActivityUseCase',
    Labra__AWS_Marketplace_Engagement_Score__c: 'engagementScore',
    Labra__Other_Industry__c: 'otherIndustry',
    Labra__Other_Competitive_Tracking__c: 'otherCompetitiveTracking',
    Labra__PDM__c: 'pdmName',
    Labra__PDM_Email__c: 'pdmEmail',
    Labra__Other_PDM_Email__c: 'wwpsPdmEmail',
    Labra__Other_PDM__c: 'wwpsPdm',
    Labra__Sync_to_AWS__c: 'syncToAws',
    Labra__awsSFCampaignName__c: 'marketingCampaignCode',
    Labra__Labra_ACE_CRM_Lead_UniqueIdentifier__c: 'aceId',
    Labra__apnReviewerComments__c: 'reviewerComments',
    Labra__Other_Solution_Offered__c: 'otherSolutionOffered',
    Labra__Parent_Opportunity_ID__c: 'parentOpportunityId',
    Labra__Partner_Contact_Title__c: 'partnerSalesContactTitle',
    Labra__AWS_Recommended_Action__c: 'recommendedNextBestActions',
    Labra__Last_Updated_By__c: 'lastUpdatedBy',
    Labra__ACE_Created_Date__c: 'createdDate',
    Labra__ACE_Last_Modified_Date__c: 'lastModifiedDate',
    Labra__MDF_Needed__c: 'marketingFundsUsed',
    Labra__Campaign_Name__c: 'apnProgram',
    Labra__Customer_Segment__c: 'customerSegment',
    Labra__isGreenfield__c: 'isGreenfield',
  }
export const assignNewKeys = <A extends object, B extends object>(
  obj: A,
  newKeys: Record<keyof A, keyof B>
): B => {
  const keyValues = Object.keys(obj).map(key => {
    const newKey = newKeys[key as keyof A] || null
    return newKey && { [newKey]: obj[key as keyof A] }
  })
  return Object.assign({}, ...keyValues)
}
/**
 * The funding payload keys its programs by display name (e.g. "Proof Of Concept
 * Funding program"). Flatten that map into a list carrying the name as a value,
 * so consumers get a plain ordered array instead of dynamic display-name keys.
 */
const flattenFundingPrograms = (
  funding: ReferralsContent['funding']
): ReferralsContent['funding'] => {
  if (!funding) return funding
  const programs = (funding.programs || {}) as Record<
    string,
    Record<string, unknown>
  >
  return {
    ...funding,
    programs: Object.entries(programs).map(([name, program]) => ({
      ...program,
      name,
    })),
  }
}

export const getReferralObjectTransformed = (
  referralsResponse: ReferralsResponse
): ReferralObject[] => {
  const referralObject = referralsResponse.referrals
  return referralObject.map((referral: ReferralsContent) => {
    const referralCamelize = camelize({
      ...referral,
      ...(referral.funding
        ? { funding: flattenFundingPrograms(referral.funding) }
        : {}),
    })
    const referralObject = referral.referral_object || {}

    const renamedObj = assignNewKeys(
      referralObject,
      mapKeysReferralApiToReferral
    )
    const referralTransformed = {
      ...referralCamelize,
      referralObject: renamedObj,
    }

    return referralTransformed
  })
}
export const getCategoryByValue = (
  object: Record<string, object>,
  key: string
) => {
  return Object.entries(object)
    .map(([k, v]) => {
      if (Object.prototype.hasOwnProperty.call(v, key)) {
        return k
      }
    })
    .find(v => !!v)
}

export const mapReferralSyncStatusToSyncStatus: Record<
  ReferralSyncStatus | SyncStatusV3Type,
  SyncStatusState
> = {
  success: 'success',
  Failed: 'error',
  error: 'error',
  in_progress: 'progress',
  warning: 'warning',
}

export const mapReferralSyncStatusLabel: Record<ReferralSyncStatus, string> = {
  success: 'Successful',
  Failed: 'Failed',
  error: 'Failed',
  in_progress: 'In progress',
  warning: 'Warning',
}

export type ErrorObj = {
  [key: string]: string
}

export type JsonError = {
  errors: Array<string> | string | ErrorObj | unknown[]
}

export type ValidJsonError = {
  errors: Array<string>
}

const toFallbackErrorString = (value: unknown): string => {
  if (typeof value === 'string') {
    return value.replace(/\\"/g, '"')
  }
  if (value == null) {
    return ''
  }
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}

export const parseResultJsonError = (
  errorInput: string | object | null | undefined
): ValidJsonError => {
  // Handle null/undefined/empty cases
  if (
    errorInput == null ||
    errorInput === '' ||
    errorInput === 'null' ||
    errorInput === 'undefined'
  ) {
    return { errors: [] }
  }

  const isValidJson = (str: string): boolean => {
    try {
      JSON.parse(str)
      return true
    } catch {
      return false
    }
  }

  try {
    let parsed: any

    // API sometimes returns already-parsed JSON objects instead of strings
    if (typeof errorInput === 'object') {
      parsed = errorInput
    } else if (!isValidJson(errorInput)) {
      // It’s not valid JSON — treat as raw string and wrap it
      parsed = { errors: [errorInput.replace(/\\"/g, '"')] }
    } else {
      parsed = JSON.parse(errorInput)
    }

    // Case: raw array of strings
    if (Array.isArray(parsed)) {
      return { errors: parsed }
    }

    // Case: standard structure
    if (Array.isArray(parsed.errors)) {
      // Handle case where errors array contains objects with message property
      const processedErrors = parsed.errors.map((error: any) => {
        if (typeof error === 'string') {
          return error
        }
        if (error && typeof error === 'object' && error.message) {
          return error.message
        }
        if (error && typeof error === 'object' && error.exceptionMessage) {
          return error.exceptionMessage
        }
        // Fallback: stringify the error object
        return JSON.stringify(error)
      })
      return { errors: processedErrors }
    }

    // Case: nested `errors.errors`
    if (
      typeof parsed.errors === 'object' &&
      Array.isArray(parsed.errors.errors)
    ) {
      return { errors: parsed.errors.errors }
    }

    // Case: single string error
    if (typeof parsed.errors === 'string') {
      return { errors: [parsed.errors] }
    }

    // Case: nested message or exceptionMessage
    if (
      typeof parsed.errors === 'object' &&
      (parsed.errors.message || parsed.errors.exceptionMessage)
    ) {
      return {
        errors: [parsed.errors.message || parsed.errors.exceptionMessage],
      }
    }

    // Case: Azure / Microsoft error envelope or generic error object
    if (parsed.error) {
      const nested = parsed.error.error || parsed.error
      if (typeof nested === 'string') {
        return { errors: [nested] }
      }
      if (nested && typeof nested === 'object') {
        if (typeof nested.message === 'string' && nested.message.trim()) {
          return { errors: [nested.message] }
        }
        if (
          typeof nested.exceptionMessage === 'string' &&
          nested.exceptionMessage.trim()
        ) {
          return { errors: [nested.exceptionMessage] }
        }
      }
    }

    if (typeof parsed.message === 'string' && parsed.message.trim()) {
      return { errors: [parsed.message] }
    }

    throw new Error('Unrecognized error structure')
  } catch (e) {
    console.warn('parseResultJsonError fallback', errorInput)
    errorLogger(e as Error, {
      message: { error: errorInput },
    })

    return {
      errors: [toFallbackErrorString(errorInput)],
    }
  }
}

export const mapReferralApiToReferral = (
  referralFromAPI: Partial<ReferralAPI>
): Referral => {
  const renamedObj = assignNewKeys(
    referralFromAPI,
    mapKeysReferralApiToReferral
  )
  return renamedObj
}

export const mapLeadApiToLead = (
  leadFromAPI: Partial<ReferralLeadAPI>
): ReferralLead => {
  const renamedObj = assignNewKeys(leadFromAPI, mapKeysLeadApiToLead)
  return renamedObj
}

export const removeEmptyValues = (data: Record<string, unknown>) => {
  return Object.entries(data).reduce((acc, [key, value]) => {
    if (value !== undefined && value !== '') {
      return {
        ...acc,
        [key]: value,
      }
    }
    return acc
  }, {})
}
export const resetAlertMessage: AppAlertState = {
  message: undefined,
  messageType: 'NONE',
}

export const mapReferralStatusToChipStatus: Record<
  ReferralStatus,
  StatusChipsState
> = {
  Approved: 'success',
  Rejected: 'error',
  'In review': 'infoSecondary',
  Submitted: 'infoSecondary',
  Accepted: 'success',
  Draft: 'draft',
  'Action Required': 'warning',
}

export const mapReferralStageToChipStatus: Record<
  ReferralStage | LeadStage,
  StagesChipsState
> = {
  Launched: 'success',
  'Closed Lost': 'error',
  Prospect: 'info',
  'Business Validation': 'info',
  Committed: 'info',
  'Technical Validation': 'info',
  Qualified: 'success',
  Open: 'info',
  Disqualified: 'error',
  Research: 'info',
}

export const getCloudAccountsForMappingManager = (
  cloudAccounts: CloudAccountType[],
  disabledClouds: CloudType[]
) => {
  return cloudAccounts.map(account => {
    return {
      ...account,
      disabled: disabledClouds.includes(account.provider as CloudType),
    }
  })
}

export const getDirectionFrom = (
  direction: SyncDirection,
  cloudName = 'ACE'
): string =>
  ({
    ace_to_crm: `${cloudName} → CRM`,
    crm_to_ace: `CRM → ${cloudName}`,
  })[direction]

type AccelerateProgramState = {
  customForm?: {
    hubspotForm?: {
      customData?: {
        labraSettingObject?: {
          accelerate_program?: boolean | null
        }
      }
    }
  }
}

/** Matches UI default (`?? false`) for accelerate_program across referral forms. */
export const getIsAccelerateProgramFromStoreState = (
  state: AccelerateProgramState
): boolean =>
  Boolean(
    state.customForm?.hubspotForm?.customData?.labraSettingObject
      ?.accelerate_program ?? false
  )

/** Required SaaS documentation fields when moving to Launched for Accelerate program (is_accelerated_program). */
export const getRequiredSaasDocumentationErrorsForAccelerateProgramLaunch = (
  form: ReferralOppSections
): Record<string, string> => {
  const saasData = form.saasDocumentation
  const isFieldEmpty = (value: unknown) =>
    value === null || value === undefined || value === ''

  const requiredSaasFields: {
    key: keyof SaaSDocumentation
    message: string
  }[] = [
    {
      key: 'contractEffectiveDate',
      message: contractEffectiveDateRequiredMessage,
    },
    {
      key: 'contractExpirationDate',
      message: contractExpirationDateRequiredMessage,
    },
    { key: 'currency', message: saasDocumentationCurrencyRequiredMessage },
    {
      key: 'customerSoftwareValue',
      message: customerSoftwareValueRequiredMessage,
    },
    { key: 'procurementType', message: procurementTypeRequiredMessage },
  ]

  const errorMap: Record<string, string> = {}
  requiredSaasFields.forEach(({ key, message }) => {
    if (isFieldEmpty(saasData?.[key])) {
      errorMap[key] = message
    }
  })
  return errorMap
}
